import { render, staticRenderFns } from "./product-class-editor.vue?vue&type=template&id=4863641e"
import script from "./product-class-editor.vue?vue&type=script&lang=ts"
export * from "./product-class-editor.vue?vue&type=script&lang=ts"
import style0 from "./product-class-editor.vue?vue&type=style&index=0&id=4863641e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports